/* eslint-disable @angular-eslint/component-selector */
import { Component, OnInit, OnDestroy, Inject, ElementRef } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { combineLatest, filter, Subscription, switchMap, take, tap } from 'rxjs';

import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { UserModel } from '../../../Core/Users/models/user.model';
import { LandingPageService } from 'app/LandingPage/services/landingPage.service';
import { RecentActivities } from 'app/LandingPage/models/recent-activities.model';
import { LandingPageFeatureModule } from 'app/LandingPage/models/feature-module.model';

@Component({
    selector: 'agpr-landingPage',
    templateUrl: './landingPage.component.html',
    styleUrls: ['./landingPage.component.scss'],
    providers: [LandingPageService],
    standalone: false
})
export class LandingPageComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];
    showWelcomeMessage: boolean = false;
    isImpersonating: boolean = false;
    landingPageWelcomeMessage: string;
    user: UserModel;
    sortedFeatures: LandingPageFeatureModule[] = [];
    id: string = 'landingPage';
    recentActivities: RecentActivities[];
    userRecentActivities: RecentActivities[];
    loading: boolean;
    isReseller: boolean;
    hasAnyModulePermissions: boolean;

    constructor(
        private currentUserStateService: CurrentUserStateService,
        private localizationService: LocalizationService,
        private ref: ElementRef,
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        private landingPageService: LandingPageService
    ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.currentUserStateService.getState().pipe(
                filter(x => !!x),
                take(1),
                tap(userState => {
                    this.loading = true;
                    this.isImpersonating = !!userState.impersonator;
                    this.showWelcomeMessage = !this.isImpersonating;
                    this.user = userState.user;
                    this.setLandingPageWelcomeMessage();
                    this.landingPageService.initializeDataServices();
                    this.landingPageService.setupSubscriptions();
                }),
                switchMap(userState => {
                    return combineLatest([
                        this.landingPageService.loadAllRecentActivities(10, userState.user.id),
                        this.landingPageService.loadAllRecentActivities(10)
                    ]);
                }),
                tap(([userActivities, recentActivities]) => {
                    this.userRecentActivities = userActivities;
                    this.recentActivities = recentActivities;
                    this.loading = false;
                })
            ).subscribe(),

        );

        this.subscriptions.push(
            this.landingPageService.isReseller$.subscribe(value => this.isReseller = value),
            this.landingPageService.hasAnyModulePermissions$.subscribe(value => this.hasAnyModulePermissions = value),
            this.landingPageService.sortedFeatures$.subscribe(features => this.sortedFeatures = features)
        );
    }

    setLandingPageWelcomeMessage() {
        this.landingPageWelcomeMessage = this.localizationService.transform('PrimaryNav.landingPageWelcomeMessage',
            {
                userName: this.user.getDisplayName()
            });
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
